import { render, staticRenderFns } from "./cookie-banner.vue?vue&type=template&id=60bb149e&scoped=true&"
import script from "./cookie-banner.vue?vue&type=script&lang=js&"
export * from "./cookie-banner.vue?vue&type=script&lang=js&"
import style0 from "./cookie-banner.vue?vue&type=style&index=0&id=60bb149e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb149e",
  null
  
)

export default component.exports